// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"733dbcb7","455":"331e457e","644":"a344b65a"}[chunkId] + ".chunk.js";
};